
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoModule } from '@jsverse/transloco';
import { SidebarPlaceholderComponent } from 'libs/shared/ui-common/src/lib/components/sidebar-placeholder/sidebar-placeholder.component';

import { ComponentWidget, GuidelineComponentType } from '@treetop/shared/model';

import { GuidelineComponentSidebarActionComponent } from './components/guideline-component-sidebar-action/guideline-component-sidebar-action.component';
import { GuidelineComponentSidebarConditionComponent } from './components/guideline-component-sidebar-condition/guideline-component-sidebar-condition.component';
import { GuidelineComponentSidebarCriteriaComponent } from './components/guideline-component-sidebar-criteria/guideline-component-sidebar-criteria.component';
import { GuidelineComponentSidebarObservationComponent } from './components/guideline-component-sidebar-observation/guideline-component-sidebar-observation.component';

@Component({
  standalone: true,
  imports: [
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    MatTabsModule,
    TranslocoModule,
    GuidelineComponentSidebarActionComponent,
    GuidelineComponentSidebarConditionComponent,
    GuidelineComponentSidebarCriteriaComponent,
    GuidelineComponentSidebarObservationComponent,
    SidebarPlaceholderComponent,
    FormsModule,
    ],
  selector: 'guideline-editor-component-sidebar-wrapper',
  templateUrl: './guideline-editor-component-sidebar-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./guideline-editor-component-sidebar-wrapper.component.scss'],
})
export class GuidelineEditorComponentSidebarWrapperComponent {
  protected widget = input.required<ComponentWidget>();

  protected GuidelineComponentType = GuidelineComponentType;
}
